import { TypeOptions } from 'react-toastify'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface IPromiseToast {
  content: string
  status: boolean
  callback: (() => Promise<any>) | undefined
  messageLoading?: string
  messageError?: string
}
interface CommonState {
  notifications: {
    content: string
    type: TypeOptions | undefined
    isPromise?: IPromiseToast
  }
}

interface CommonAction {
  setNoti: (content: string, type: TypeOptions | undefined, wait?: number) => void

  clearNoti: () => void
  setNotiPromise: ({ content, status, callback, messageLoading, messageError }: IPromiseToast) => void
}

const defaultValue: CommonState = {
  notifications: {
    content: '',
    type: 'success',
    isPromise: {
      content: '',
      status: false,
      callback: undefined,
      messageLoading: '',
      messageError: '',
    },
  },
}
let timeOut
export const useCommonStore = create<CommonState & CommonAction>()(
  devtools(
    (set, get) => ({
      notifications: defaultValue?.notifications,
      setNoti: (content, type, wait) => {
        set((state) => ({
          notifications: { ...state.notifications, content: content, type: type ?? 'success' },
        }))
        timeOut = setTimeout(() => {
          get().clearNoti()
        }, wait ?? 3000)
      },
      setNotiPromise: async ({ content, callback, messageLoading, messageError }) => {
        const isPromise = {
          status: true,
          callback,
          messageLoading,
          content,
          messageError,
        }
        set((state) => ({
          notifications: {
            ...state.notifications,
            content,
            type: 'success',
            isPromise,
          },
        }))
      },
      clearNoti: () => set(() => defaultValue),
    }),
    {
      name: 'common-storage',
    }
  )
)
